import { render, staticRenderFns } from "./ReservationCard.vue?vue&type=template&id=37bde1a1&scoped=true&"
import script from "./ReservationCard.vue?vue&type=script&lang=ts&"
export * from "./ReservationCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationCard.vue?vue&type=style&index=0&id=37bde1a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bde1a1",
  null
  
)

export default component.exports